export const FEEDBACK_PREDICTIONS_LIMIT = 4; 